import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';

import uboDetailsFields from 'utils/fiserv/uboDetails';
import { TraxxField } from 'components/TraxxField';
import STYLES from 'utils/fiserv/styles';

const defaultData = {
  title: "",
  firstName: "",
  lastName: "",
  middleName: "",
  dateOfBirth: "",
  nationality: "",
  shareholderPercentage: 100,
  addressLine: "",
  addressLine2: "",
  addressLine3: "",
  city: "",
  state: "",
  pincode: "",
  country: "",
  phone1: "",
  phone2: "",
  contactName: "",
  kycCategory: "POI",
  identityType: "PASSPORT",
  identityValue: ""
}

const Step3 = ({ merchant, handleNext }) => {

  const [ uboDetails, setUboDetails ] = useState([defaultData]);

  useEffect(() => {
    if (!merchant) return;
    if (merchant.uboDetails) {
      setUboDetails(JSON.parse(merchant.uboDetails))
    } else if (merchant.selectedMerchant) {
      const info = JSON.parse(merchant.selectedMerchant);
      setUboDetails([{
        ...defaultData,
        firstName: info.firstName,
        lastName: info.lastName,
        addressLine: info.address,
        country: info.country,
        city: info.country === "Singapore" ? "Singapore" : "",
        state: info.country === "Singapore" ? "Singapore" : "",
        phone1: info.contactNum,
        contactName: info.firstName + " " + info.lastName,
      }])
    }
  }, [merchant])

  const removeUbo = (indexToRemove) => {
    setUboDetails(prev => 
      prev.filter((item, index) => index !== indexToRemove)
    );
  }

  const addUbo = () => {
    setUboDetails(prev => [
      ...prev,
      defaultData
    ]);
  }

  const handleChange = (ev, index) => {
    const { name, value } = ev.target;
    setUboDetails(prev => {
      const updatedData = [...prev];
      updatedData[index] = { ...updatedData[index], [name]: value }
      return updatedData;
    })
  }
  
  return <>

    {
      uboDetails.map((ubo, index) => (
        <Box key={index} sx={ STYLES.box }>
          <Box sx={ STYLES.header }>
            <Typography>UBO {index+1}</Typography>
            { 
              uboDetails.length !== 1 && 
              <IconButton aria-label="delete" onClick={() => removeUbo(index)}><CancelIcon /></IconButton>
            }
          </Box>
          <Grid container spacing={2} style={ STYLES.innerBox }>
            <TraxxField
              arr={uboDetailsFields}
              data={ubo}
              handleChange={(ev) => handleChange(ev, index)}
            />
          </Grid>
        </Box>
      ))
    }

    { 
      uboDetails.length < 3 && 
      <Button sx={{ mb: 1 }} variant="outlined" fullWidth onClick={addUbo}>Add UBO</Button>
    }

    <Grid item xs={12} sx={{ mt: 3 }}>
      <Button variant="contained" fullWidth onClick={() => handleNext(uboDetails, "uboDetails")}>
        Save
      </Button>
    </Grid>
    
  </>
}

export default Step3;